/** 此文件主要用于搜狗ocpc应用api转化对接 **/
import globalConfig from '@/lib/http/global-config'
const BASE_URL = globalConfig.eBaseUrl
export default {
  methods: {
    async requestSougou() {
      console.log('执行ocpc----------')
      this.$axios.defaults.withCredentials = true
      try {
        const res = await this.$axios({
          url: '/open/sogou/ocpc',
          method: 'post',
          baseURL: BASE_URL,
          data: {
            conversions: [
              {
                logidUrl: window.location.href,
                convertType: 3,
                deviceType: 2,
                isConvert: 1,
                convertTime: Math.round(new Date() / 1000),
                confidence: 100,
              },
            ],
          },
        })
        console.log('查看请求结果ocpc----------', res)
      } catch (err) {
        console.log('ocpc执行失败', err)
      }
    },
  },
}
